<template>
    <div class="page-func-test">
        <ul class="container">
            <li class="item">
                <p class="item-title">1、跳转到对应APP的对应页面</p>
                <div class="item-box">
                    <cube-select
                            class="select"
                            v-model="activeJumpTypesValue"
                            :options="activeJumpOptions">
                    </cube-select>
                    <cube-button class="button" @click="handleActiveJump">确定</cube-button>
                </div>
            </li>
            <li class="item">
                <p class="item-title">2、能根据包名，跳转到相应的详情页 / 拉起游戏</p>
                <div class="item-box">
                    <cube-input placeholder="请输入包名" class="select" v-model="packageName" />
                    <cube-button class="button" @click="handleCampaignWebToGameDetail">跳转</cube-button>
                    <cube-button class="button" @click="handlePlayGame">拉起</cube-button>
                </div>
            </li>
            <li class="item">
                <p class="item-title">2、可以调用分享</p>
                <div class="item-box">
                    <cube-select
                            class="select"
                            v-model="shareValue"
                            :options="shareOptions">
                    </cube-select>
                    <cube-button class="button" @click="handleShare">确定</cube-button>
                </div>
            </li>
            <li class="item">
                <p class="item-title">4、能够直接拉起手机内指定包名的APP</p>
                <div class="item-box">
                    <cube-input placeholder="请输入包名" class="select" v-model="thirdPackageName" />
                    <cube-button class="button" @click="handleOpenThirdAppWithPackageName">拉起</cube-button>
                </div>
            </li>
            <li class="item">
                <p class="item-title">5、获取用户信息</p>
                <div class="item-box">
                    <cube-button @click="handleGetUserInfo">获取</cube-button>
                </div>
            </li>
            <li class="item">
                <p class="item-title">6、跳转登录</p>
                <div class="item-box">
                    <cube-button @click="handleCampaignWebToLoginActivity">跳转</cube-button>
                </div>
            </li>
            <li class="item">
                <p class="item-title">7、复制内容到剪切板</p>
                <div class="item-box">
                    <cube-input placeholder="请输入分享的内容" class="select" v-model="copyText" />
                    <cube-button class="button" @click="handleCopyCampaignWebText">确定</cube-button>
                </div>
            </li>
            <li class="item">
                <p class="item-title">8、能让用户上传图片</p>
                <div class="item-box">
                    <cube-button @click="handleCampaignWebUploadFile">上传</cube-button>
                </div>
            </li>
            <li class="item">
                <p class="item-title">9、网页顶部通用栏</p>
                <div class="item-box">
                    <cube-button @click="handleFinishWeb">销毁页面</cube-button>
                </div>
                <div class="item-box">
                    <cube-button @click="handleOpenCustomerService">跳转客服</cube-button>
                </div>
                <div class="item-box">
                    <cube-button @click="handleShowService">显示客服</cube-button>
                </div>
                <div class="item-box">
                    <cube-button @click="handleHideService">隐藏客服</cube-button>
                </div>
            </li>
            <li class="item">
                <p class="item-title">10、获取版本信息</p>
                <div class="item-box">
                    <cube-button @click="handleGetAppVersionCode">获取版本号</cube-button>
                </div>
                <div class="item-box">
                    <cube-button @click="handleGetAppVersionName">获取版本名称</cube-button>
                </div>
                <div class="item-box">
                    <cube-button @click="handleGetAppChannel">获取渠道号</cube-button>
                </div>
            </li>
            <li class="item">
                <p class="item-title">11、看广告</p>
                <div class="item-box">
                    <cube-button @click="handleCampaignShowAdVideo">确定</cube-button>
                </div>
            </li>
            <li class="item">
                <p class="item-title">12、绑定微信</p>
                <div class="item-box">
                    <cube-button @click="handleBindWeChat">确定</cube-button>
                </div>
            </li>
            <li class="item">
                <p class="item-title">13、微信支付</p>
                <div class="item-box">
                    <cube-button @click="handleWechatPay">确定</cube-button>
                </div>
            </li>
            <li class="item">
                <p class="item-title">14、标题相关</p>
                <div class="item-box">
                    <cube-button @click="handleShowPhoneTitle">展示标题</cube-button>
                </div>
                <div class="item-box">
                    <cube-button @click="handleHidePhoneTitle">隐藏标题</cube-button>
                </div>
            </li>
            <li class="item">
                <p class="item-title">15、拦截原生返回键</p>
                <div class="item-box">
                    <cube-button @click="handleInterceptSystemBack">确认</cube-button>
                </div>
            </li>
            <li class="item">
                <p class="item-title">16、跳转外部浏览器打开链接</p>
                <div class="item-box">
                    <cube-button @click="handleOpenBrowser">确认</cube-button>
                </div>
            </li>
            <li class="item">
                <p class="item-title">17、获取内部安装的应用列表</p>
                <div class="item-box">
                    <cube-button @click="handleGetInternalInstalledApp">确认</cube-button>
                </div>
            </li>
            <li class="item">
                <p class="item-title">18、打开游戏详情</p>
                <div class="item-box">
                    <cube-button @click="handleOpenGameDetail">确认</cube-button>
                </div>
            </li>
            <li class="item">
                <p class="item-title">19、贴片广告</p>
                <div class="item-box">
                    <cube-button @click="handleShowCampaignMessageDialog">确认</cube-button>
                </div>
            </li>
            <li class="item">
                <p class="item-title">20、获取包名</p>
                <div class="item-box">
                    <cube-button @click="handleGetPackageName">获取</cube-button>
                </div>
            </li>
            <li class="item">
                <p class="item-title">21、是否已下载</p>
                <div class="item-box">
                    <cube-input placeholder="请输入包名" class="select" v-model="packageName" />
                    <cube-button class="button" @click="handleIsDownloaded">获取</cube-button>
                </div>
            </li>
            <li class="item">
                <p class="item-title">22、下载apk</p>
                <p class="item-title">包名：air.com.a77375.mycutepuppy,如果已经下载，点击之后直接打开</p>
                <p class="item-title">下载的进度：{{speed}}</p>
                <p class="item-title">下载的状态：{{status}}</p>
                <div class="item-boxtwo">
                    <cube-button @click="handleDownloadApkByPkg">下载</cube-button>
                </div>
            </li>
            <li class="item">
                <p class="item-title">23、停止下载apk</p>
                <div class="item-box">
                    <cube-input placeholder="请输入包名" class="select" v-model="packageName" />
                    <cube-button class="button" @click="handleStopDownload">停止</cube-button>
                </div>
            </li>
            <li class="item">
                <p class="item-title">24、是否已安装apk(pkg)</p>
                <div class="item-box">
                    <cube-input placeholder="请输入包名" class="select" v-model="packageName" />
                    <cube-button class="button" @click="handleIsInstalledPkg">获取</cube-button>
                </div>
            </li>
            <li class="item">
                <p class="item-title">25、打开app</p>
                <div class="item-boxtwo">
                    <cube-input placeholder="请输入包名" class="select item-input" v-model="packageName" />
                    <cube-button @click="handleOpenApp">打开</cube-button>
                </div>
            </li>
            <li class="item">
                <p class="item-title">26、获取App使用时长</p>
                <div class="item-boxtwo">
                    <cube-input placeholder="开始时间" class="select item-input" v-model="startTimeMills" />
                    <cube-input placeholder="结束时间" class="select item-input" v-model="endTimeMills" />
                    <cube-input placeholder="请输入包名" class="select item-input" v-model="packageName" />
                    <cube-button @click="handleFetchPkgPlayTime">获取</cube-button>
                </div>
            </li>
            <li class="item">
                <p class="item-title">27、安装apk</p>
                <div class="item-boxtwo">
                    <cube-input placeholder="请输入包名" class="select item-input" v-model="packageName" />
                    <cube-button @click="handleInstallApk">安装</cube-button>
                </div>
            </li>
        </ul>
    </div>
</template>

<script>
    // import './common.js';
    export default {
        name: "FuncTest",
        data() {
            return {
                activeJumpOptions: ['任务', '刮卡', '挑战', '详情', '网页', '邀请', 'cpl', '双色球', '一元打卡', '小程序', 'cpa', '我的界面', '货币提现', '闲玩'],
                activeJumpTypesValue: '任务',
                packageName: '',
                shareOptions: ['多个分享', '微信', '朋友圈', 'QQ', 'QQ 空间'],
                shareValue: '多个分享',
                thirdPackageName: '',
                copyText: '',
                speed: 0,
                status: null,
                startTimeMills: '',
                endTimeMills: '',
            }
        },
        mounted() {

            window['showAdVideoFailed'] = () => {
                this.$createToast({txt: '广告视频播放失败!', type: ''}).show();
            };
            window['uploadImage'] = (url) => {
                this.$createDialog({type: 'alert', content: url}).show();
            };
            window['startAppSuccess'] = () => {
                this.$createToast({txt: '拉起外部APP成功!', type: ''}).show();
            };
            window['startAppFailed'] = () => {
                this.$createToast({txt: '拉起外部APP失败!', type: ''}).show();
            };
            window['appNotInstall'] = () => {
                this.$createToast({txt: '外部APP没有安装!', type: ''}).show();
            };
            window['startGameSuccess'] = () => {
                this.$createToast({txt: '拉起游戏成功!', type: ''}).show();
            };
            window['startGameFailed'] = () => {
                this.$createToast({txt: '拉起游戏失败!', type: ''}).show();
            };
            window['gameNotInstall'] = () => {
                this.$createToast({txt: '游戏没有安装!', type: ''}).show();
            };
            window['deviceInstalledApp'] = (arr) => {
                this.$createDialog({
                    type: 'alert',
                    content: JSON.stringify(JSON.parse(arr), null, 2),
                }).show();
            };
            window['getInternalInstalledApp'] = (arr) => {
                this.$createDialog({
                    type: 'alert',
                    content: JSON.stringify(JSON.parse(arr), null, 2),
                }).show();
            };
            window['wechatPaySuccess'] = (wxOrderID, isSuccess) => {
                console.log(wxOrderID, isSuccess);
                if (~~isSuccess === 1) {
                    this.$createDialog({
                        type: 'alert',
                        content: wxOrderID,
                    }).show();
                } else {
                    this.$createToast({txt: '支付失败...', type: ''}).show();
                }
            };
            window['AndroidWeChatAuthorSuccess'] = () => {
                this.$createToast({txt: '微信绑定成功!', type: ''}).show();
            };
            window['AndroidWeChatAuthorFailed'] = () => {
                this.$createToast({txt: '微信绑定失败!', type: ''}).show();
            };
            //返回页面的方法
            window['AndroidLifeOnResume'] = () => {
                console.log('返回到这个页面就是执行这个函数')
            };
            //下载状态的回调
            //pkg:包名，gid:游戏id，status:下载的状态 1.暂停, 2.成功, 3.失败,
            window['downloadStatus'] = (pkg, gid, status) => {
                this.status = status;
                console.log('包名', pkg);
                console.log('游戏id', gid);
                console.log('游戏的状态', status);
            };
            //下载进度的回调
            window['downloadProgress'] = (pkg, gid, progress) => {
                const num = progress * 100;
                this.speed = num.toFixed(2) + '%';
            };
            //app使用时长的回调
            window['callbackFetchPkgPlayTime'] = (pkg,timeMills) => {
                this.gamttime = timeMills;
                console.log('包名', pkg);
                console.log('游戏时长', timeMills);
            };
        },
        methods: {
            handleActiveJump() {
                const type = this.activeJumpOptions.indexOf(this.activeJumpTypesValue) + 1;
                switch (type) {
                    case 4:
                        Android.activeJump(type, 'com.gramgames.mergedragons');
                        break;
                    case 5:
                        Android.activeJump(type, 'http://233xyx.com/');
                        break;
                    case 10:
                        Android.activeJump(type, 'wx1f98b4ecb1e2c2fb');
                        break;
                    default:
                        Android.activeJump(type);
                        break;
                }
            },
            handleCampaignWebToGameDetail() {
                Android.campaignWebToGameDetail(this.packageName);
            },
            handlePlayGame() {
                Android.playGame(this.packageName)
            },
            handleShare() {
                const shareInfo = {
                    shareTitle: '听说有人靠这个都赚了好几百了咱们也来试试啊[红包] ${url}',
                    shareDetail: '我正在边玩游戏边赚钱,已经赚疯了!',
                    imageUrl: 'https://cdn.233xyx.com/upload/image/haiyu.hu1554730834249/lALPDgQ9qkLoWNlYWA_88_88.png_620x10000q90g.jpg',
                    shareUrl: 'http://test.app.233wei.cn/public/open.html',
                    analyticsType: 5,
                    qqTitle: '听说有人靠这个都赚了好几百了咱们也来试试啊[红包] ${url}',
                    qqContent: '我正在边玩游戏边赚钱,已经赚疯了!',
                };
                switch (this.shareValue) {
                    case '多个分享':
                        Android.shareWebByType(1, shareInfo.shareTitle, shareInfo.shareDetail, shareInfo.imageUrl, shareInfo.shareUrl, shareInfo.analyticsType, shareInfo.qqTitle, shareInfo.qqContent, '', false,-1,-1);
                        break;
                    case '微信':
                        Android.shareWebByType(1, shareInfo.shareTitle, shareInfo.shareDetail, shareInfo.imageUrl, shareInfo.shareUrl, shareInfo.analyticsType, shareInfo.qqTitle, shareInfo.qqContent, '', true,-1,-1);
                        break;
                    case '朋友圈':
                        Android.shareWebByWeChatMoment(1, shareInfo.shareTitle, shareInfo.shareDetail, shareInfo.imageUrl, shareInfo.shareUrl, shareInfo.analyticsType, '',-1,-1);
                        break;
                    case 'QQ':
                        Android.shareWebByQQ(1, shareInfo.shareTitle, shareInfo.shareDetail, shareInfo.imageUrl, shareInfo.shareUrl, shareInfo.analyticsType, shareInfo.qqTitle, shareInfo.qqContent, '',-1,-1);
                        break;
                    case 'QQ 空间':
                        Android.shareWebByQQZone(1,  shareInfo.shareTitle, shareInfo.shareDetail, shareInfo.imageUrl, shareInfo.shareUrl, shareInfo.analyticsType, shareInfo.qqTitle, shareInfo.qqContent, '',-1,-1);
                        break;
                    default:
                        return;
                }
            },
            handleOpenThirdAppWithPackageName() {
                Android.openThirdAppWithPackageName(this.thirdPackageName);
            },
            handleGetUserInfo() {
                this.$createDialog({
                    type: 'alert',
                    content: JSON.stringify(JSON.parse(Android.getUserInfo()), null, 1),
                }).show();
            },
            handleCampaignWebToLoginActivity() {
                Android.campaignWebToLoginActivity();
            },
            handleCopyCampaignWebText() {
                Android.copyCampaignWebText(this.copyText);
            },
            handleCampaignWebUploadFile() {
                Android.campaignWebUploadFile();
            },
            handleFinishWeb() {
                Android.finishWeb();
            },
            handleOpenCustomerService() {
                Android.openCustomerService();
            },
            handleShowService() {
                Android.showService();
            },
            handleHideService() {
                Android.hideService();
            },
            handleGetAppVersionCode() {
                this.$createDialog({
                    type: 'alert',
                    content: JSON.stringify(Android.getAppVersionCode(), null, 1),
                }).show();
            },
            handleGetAppVersionName() {
                this.$createDialog({
                    type: 'alert',
                    content: JSON.stringify(Android.getAppVersionName(), null, 1),
                }).show();
            },
            handleGetAppChannel() {
                this.$createDialog({
                    type: 'alert',
                    content: JSON.stringify(Android.getAppChannel(), null, 1),
                }).show();
            },
            handleCampaignShowAdVideo() {
                Android.campaignShowAdVideo();
            },
            handleBindWeChat() {
                Android.bindWeChat();
            },
            handleWechatPay() {
                fetch('/api/auth/buy/buyByApp', {
                    method: 'POST',
                    body: JSON.stringify({
                        money: '1',
                        uuid: 'os7160R6WOEOiOmhsgLrGZT4LRI8',
                        payType:1,
                        ip:'127.0.0.1',
                        from:1,
                        orderCode:Math.random()*2222222222222222222222222222222222222222222222222222222222222222222222222222,
                        appId:'wx8e3b2d3264507e38',
                        callbackUrl:'http://baidu.com'
                    }),
                    headers: {
                    "Content-type": "application/json; charset=UTF-8"
                    }
                })
                .then(response => response.json())
                .then(json => {
                     if (json['code'] === 200) {
                        const orderData = json.data;
                        this.$createDialog({
                            type: 'alert',
                            content: JSON.stringify(
                                Android.wechatPay(JSON.stringify({
                                appid: orderData.appid,
                                partnerid: orderData.partnerid,
                                noncestr: orderData.noncestr,
                                timestamp: parseInt(orderData.timestamp),
                                prepayid: orderData.prepayid,
                                sign: orderData.sign,
                                orderid: orderData.orderid,
                            })), null, 1),
                        }).show();
                    } else {
                        this.$createToast({txt: '创建订单失败'}).show();
                    }
                })
            },
            handleShowPhoneTitle() {
                Android.showPhoneTitle();
            },
            handleHidePhoneTitle() {
                Android.hidePhoneTitle();
            },
            handleInterceptSystemBack() {
                Android.interceptSystemBack();
            },
            handleOpenBrowser() {
                Android.openBrowser('http://233xyx.com');
            },
            handleGetInternalInstalledApp() {
                Android.getInternalInstalledApp();
            },
            handleOpenGameDetail() {
                Android.openGameDetail(300000001, 1);
            },
            handleShowCampaignMessageDialog() {
                Android.showCampaignMessageDialog('你好', '今天天气不错', 'https://www.233xyx.com/public/images/operation-love.png', '测试1', 'exchangeSuccess');
            },
            handleGetPackageName() {
                this.$createDialog({
                    type: 'alert',
                    content: JSON.stringify(Android.getPackageName(), null, 1),
                }).show();
            },
             //是否已下载
            handleIsDownloaded(){
                this.$createDialog({
                    type: 'alert',
                    content: JSON.stringify(Android.isDownloaded(this.packageName), null, 1),
                }).show();
            },
            //是否安装
            handleIsInstalledPkg(){
                this.$createDialog({
                    type: 'alert',
                    content: JSON.stringify(Android.isInstalledPkg(this.packageName), null, 1),
                }).show();
            },
            //获取游戏时长
            handleFetchPkgPlayTime(){
                Android.fetchPkgPlayTime(this.startTimeMills, this.endTimeMills, this.packageName);
            },
            //下载apk
            handleDownloadApkByPkg(){
                Android.downloadApkByPkg(this.packageName)
            },
            //停止下载
            handleStopDownload() {
                Android.stopDownload(this.packageName)
            },
            //安装apk
            handleInstallApk() {
                Android.installApk(this.packageName);
            },
            //打开app
            handleOpenApp(){
                Android.openApp(this.packageName)
            },
        }
    }
</script>

<style scoped lang="less">
    .page-func-test {
        .title {
            font-size: 0.16rem;
            margin: .3rem;
        }

        .container {
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            align-items: flex-start;

            .item {
                width: 100%;
                box-sizing: border-box;
                padding: .15rem;
                font-size: .16rem;

                .item-title {
                    font-size: 0.16rem;
                    padding: .1rem;
                }

                .item-box {
                    margin: .104rem 0;
                    width: 100%;
                    display: flex;
                    justify-content: center;
                    align-items: center;

                    .select {
                        flex: 1;
                        padding-bottom: .05rem;
                    }

                    .button {
                        width: .8rem;
                        line-height: .1rem;
                        margin: 0 .1rem;
                    }
                }
            }

            .item-input {
                margin-bottom: .05rem;
            }
        }
    }
</style>
